export const X_CATALOG_API_SUPPORTED_FEATURES_HEADER_NAME = 'X-Catalog-Api-Supported-Features';
export const X_CATALOG_API_SUPPORTED_FEATURES_BUYER_FACING_NAME = 'BUYER_FACING_NAME';
export const X_CATALOG_API_SUPPORTED_FEATURES_COMBOS = 'COMBOS';
export const X_CATALOG_API_SUPPORTED_FEATURES_PROGRAM_ELIGIBILITY = 'PROGRAM_ELIGIBILITY';
export const X_CATALOG_API_SUPPORTED_FEATURES_CHANNEL_INTEGRATIONS = 'CHANNEL_INTEGRATIONS';